import { StyleRules } from '@material-ui/core/styles';
import { IconButtonClassKey } from '@material-ui/core/IconButton';

import { core as theme } from '../styles/core';

export const MuiIconButton: Partial<StyleRules<IconButtonClassKey>> = {
  root: {
    padding: theme.spacing(1.25),
  },
  sizeSmall: {
    padding: theme.spacing(1),
    '& svg.MuiSvgIcon-root': {
      fontSize: 16,
    }
  },
  colorPrimary: {
    '&:focus': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.lightest,
    },
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.lightest,
    },
  },
};
